import * as React from "react";
import * as csstips from "csstips";
import { style } from "typestyle";

interface ISidebarLayoutProps {
  width: number;
  top?: React.JSX.Element | React.JSX.Element[];
  center: React.JSX.Element | React.JSX.Element[];
  bottom?: React.JSX.Element | React.JSX.Element[];
}

const SidebarLayout = ({ width, top, center, bottom }: ISidebarLayoutProps) => (
  <div
    className={style(csstips.vertical, csstips.fillParent, {
      width: `${width}px`,
    })}
  >
    {top && <div className={style({ width: "100%", zIndex: 2 })}>{top}</div>}
    <div className={style(csstips.flex, { overflow: "auto" })}>{center}</div>
    {bottom && (
      <div className={style({ width: "100%", zIndex: 1 })}>{bottom}</div>
    )}
  </div>
);

export default SidebarLayout;
